// extracted by mini-css-extract-plugin
export default {"biography":"Biography_biography__v7znN","intro":"Biography_intro__Fptnb","alt":"Biography_alt__5Wy+F","imgWrapper":"Biography_imgWrapper__zWR+6"};